import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Powering Enterprise with
            <span className="gradient-text"> Resilient Defense</span>
          </h1>
          <p className="hero-description">
            Rivontrix is a next-generation technology and consulting firm combining AI-driven cybersecurity 
            products, Generative AI solutions, and digital transformation with manpower expertise. We are not just protecting systems - 
            we're powering enterprise with resilient, intelligent defense and adaptable talent ecosystems enabled by cutting-edge GenAI.
          </p>
        </div>
        <div className="hero-visual">
          <div className="hero-grid">
            <div
              className="hero-card has-image"
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'instant' });
                const event = new CustomEvent('sectionChange', { detail: 'shieldex' });
                window.dispatchEvent(event);
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'instant' });
                  const event = new CustomEvent('sectionChange', { detail: 'shieldex' });
                  window.dispatchEvent(event);
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <div 
                className="hero-card-image" 
                style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=95&auto=format&fit=crop)' }}
              >
                <div className="hero-card-overlay"></div>
              </div>
              <div className="hero-card-content">
                <div className="hero-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <h3>ShieldEx</h3>
                <p>An AI-powered cybersecurity exposure management platform.</p>
              </div>
            </div>
            <div className="hero-card has-image">
              <div 
                className="hero-card-image" 
                style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=95&auto=format&fit=crop)' }}
              >
                <div className="hero-card-overlay"></div>
              </div>
              <div className="hero-card-content">
                <div className="hero-icon">
                  <i className="fas fa-network-wired"></i>
                </div>
                <h3>Consulting</h3>
                <p>Digital Transformation</p>
              </div>
            </div>
            <div className="hero-card has-image">
              <div 
                className="hero-card-image" 
                style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=95&auto=format&fit=crop)' }}
              >
                <div className="hero-card-overlay"></div>
              </div>
              <div className="hero-card-content">
                <div className="hero-icon">
                  <i className="fas fa-users"></i>
                </div>
                <h3>TechTalentPro</h3>
                <p>Manpower Expertise</p>
              </div>
            </div>
            <div
              className="hero-card has-image"
              onClick={() => {
                // Trigger section change to contact if parent component supports it
                const event = new CustomEvent('sectionChange', { detail: 'contact' });
                window.dispatchEvent(event);
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  const event = new CustomEvent('sectionChange', { detail: 'contact' });
                  window.dispatchEvent(event);
                }
              }}
            >
              <div 
                className="hero-card-image" 
                style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=95&auto=format&fit=crop)' }}
              >
                <div className="hero-card-overlay"></div>
              </div>
              <div className="hero-card-content">
                <div className="hero-icon">
                  <i className="fas fa-play-circle"></i>
                </div>
                <h3>Request Demo</h3>
                <p>Cybersecurity Product (ShieldEx)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

